import { Subject } from "rxjs";

const LanguageSubject = new Subject();

export { LanguageSubject };



// WEBPACK FOOTER //
// ./src/shared/LanguageSubject.js